var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWoman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icone_Woman",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.433,
    height: 30.453,
    viewBox: "0 0 11.433 14.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M10.973,3.311a6.907,6.907,0,0,1,.682.148,3.794,3.794,0,0,1,2.759,3.089,3.859,3.859,0,0,1-2.92,4.442c-.148.035-.3.058-.456.088v2.6h1.256a.431.431,0,1,1,0,.859H11.031c0,.425,0,.835,0,1.245a.6.6,0,0,1-.028.2.428.428,0,0,1-.83-.137c0-.378,0-.756,0-1.134v-.171H9.647c-.263,0-.526,0-.79,0a.429.429,0,0,1,0-.857c.43,0,.86,0,1.3,0v-2.6a3.733,3.733,0,0,1-1.6-.553A3.761,3.761,0,0,1,6.726,6.771a3.894,3.894,0,0,1,3.223-3.4c.093-.016.185-.037.278-.056Zm-.378,6.92A3.029,3.029,0,1,0,7.556,7.207,3.029,3.029,0,0,0,10.595,10.231Z",
    transform: "translate(-6.701 -3.31)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWoman);
export default __webpack_public_path__ + "static/media/icon_woman.5858af53c8d7477fc44bce6a4668e6ac.svg";
export { ForwardRef as ReactComponent };